import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ls-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['breadcrumb.component.scss'],
  // tslint:disable-next-line:use-view-encapsulation
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent {
  @Input()
  public currentLocation = '';
}
